//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const home = () => import("../components/home.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");
const howtofile = () => import("../components/howtofile.vue");

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  {
    name: "howtofile",
    path: "/howtofile",
    component: howtofile,
    display: "How To File",
    icon: "howtofile",
  },
  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
